import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { TabIndexChanged } from '../actions/tickets-actions.actions';
import { TicketsActionsState } from '../models/tickets.models';

const initialState: TicketsActionsState = {
  tabIndex: 0,
};

export const TicketActionsReducer = createReducer(
  initialState,
  on(TabIndexChanged, (state, { tabIndex }) => ({
    ...state,
    tabIndex,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => ({
    ...state,
    tabIndex: activeComponent === 'TicketMassInsertionComponent' ? 1 : 0,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
